import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Investigator tab placeholder, extracted from `CreateEntityElementComponent`.
 * Investigator creation is intentionally out of scope for this POC.
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'wcg-investigator-panel',
    templateUrl: './investigator-panel.component.html'
})
export class InvestigatorPanelComponent {
    /** Whether this panel should be visually hidden (the "inactive" tabs stay in the DOM so their data is never lost). */
    readonly hidden = input(false);
}
